import { render } from "./XmlMapperView.vue?vue&type=template&id=96c30ba6&scoped=true&ts=true"
import script from "./XmlMapperView.vue?vue&type=script&lang=ts"
export * from "./XmlMapperView.vue?vue&type=script&lang=ts"

import "./XmlMapperView.vue?vue&type=style&index=0&id=96c30ba6&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c30ba6"]])

export default __exports__